import styled from 'styled-components';

export const SwitchChoiceType = styled('div')`
  margin: 1rem 0;
  align-self: center;
`;

export const TagChoiceWrapper = styled('div')`
  display: flex;
  margin-top: 1rem;
  flex-direction: column;
`;

export const RowWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem !important;
  flex-direction: row;
  & > div {
    margin: 10px;
  }
`;

export const TagChoiceEditorFields = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  & > * {
    :first-child {
      flex: 0.5;
    }
    :nth-child(2) {
      top: 0.7rem;
      flex: 0.5;
      display: flex;
      position: relative;
      margin-inline-start: 1rem;
      @media (max-width: 720px) {
        margin-inline-start: 0;
      }
    }
  }
  @media (max-width: 720px) {
    align-items: stretch;
    flex-direction: column;
    margin-bottom: 1.5rem;
  }
`;
